/* @flow */

import React from 'react';
import { Form } from 'semantic-ui-react';
import { NETWORK_MODES } from 'catalog/constants';

type Props = {
  canOverride: boolean,
  input: Object,
  meta: Object,
  label: String,
};

const NetworkModeSelector = ({
  canOverride,
  input,
  meta: { touched, error },
  label,
}: Props) => {
  const modeChanged = (_, { value }) => input.onChange(value);

  if (canOverride) {
    return (
      <Form.Select
        {...input}
        error={touched && error}
        label={label}
        onChange={modeChanged}
        options={NETWORK_MODES}
        placeholder="Sélectionnez un mode de connectivité"
      />
    );
  }

  return null;
};

export default NetworkModeSelector;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/NetworkModeSelector.js